import React, { useEffect, useState } from "react";
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Divider,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@mui/material";
import Grid from "@mui/material/Grid";
import close from "../../assets/icons/close.png";
import { getCompanyDetailsApi, getKamProfilePicApi } from "../Services/OrgRepo";
import { ThreeDot } from "react-loading-indicators";
import {
    generateCompanyLogo,
    generatProfilePicUrl
} from "../../Utils/Constant";

function createData(
    companyId: string,
    associatedCompany: string,
    logo: string
) {
    return { companyId, associatedCompany, logo };
}

export const AssociatedCompanyDrawer = ({ open, onClose, selectedPartner }) => {
    const [loading, setLoading] = useState(false);
    const [companyData, setCompanyData] = useState([]);
    const [profileImage, setProfileImage] = useState("");
    const getCompanyData = async () => {
        setLoading(true);
        try {
            const data = await getCompanyDetailsApi(
                selectedPartner?.organisationName
            );
            if (data?.status) {
                setCompanyData(data?.data);
            } else {
                setCompanyData([]);
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            setCompanyData([]);
            console.log("Error while fetching getCompanyData");
        }
    };

    const getProfilePic = async () => {
        try {
            const data = await getKamProfilePicApi(selectedPartner?.KAMId);
            if (data?.status) {
                const img = generatProfilePicUrl(
                    selectedPartner?.KAMId,
                    data?.data,
                    "Profile_Picture"
                );
                setProfileImage(img);
            } else {
                setProfileImage("");
            }
            setLoading(false);
        } catch (err) {
            setProfileImage("");
            console.log("Error while fetching getCompanyData");
        }
    };

    useEffect(() => {
        if (selectedPartner?.organisationName) {
            getCompanyData();
            setProfileImage("");
        }
        if (selectedPartner?.KAMId) {
            getProfilePic();
        }
    }, [selectedPartner]);

    const GenerateImage = (url, id) => {
        const imgUrl = generateCompanyLogo(id, url);

        // const imgUrl = `https://creatorapp.zohopublic.in/file/arun.ramu_machinemaze/react-js-application/Organisation_Onboarding_Report/${id}/Company_Logo/image-download/r2QbqB8aOnDng5yR693qTBy60aEQXVbAjWvdFEuC0M0CJvXvv4hpZ3fVZ6UPrfRMOQEmXKkx9fnBFfvxeZmMJQSxnps1mt324E0H?filepath=${url}`;

        if (url) {
            return imgUrl;
        }
    };
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ p: 2, width: { xs: "100%", sm: 400 } }}>
                {/* Header Section */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h6" fontWeight="bold">
                        Associated Companies
                    </Typography>
                    <Box>
                        <IconButton onClick={onClose} sx={{ padding: "10px" }}>
                            <img src={close} width={"14px"} alt="Close" />
                        </IconButton>
                    </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Organisation Details */}
                <Box display="flex" alignItems="center" gap={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={5}>
                            <Typography variant="body2" color="text.secondary">
                                Organisation ID
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Typography variant="body2">
                                {selectedPartner?.orgID}
                            </Typography>
                        </Grid>

                        {selectedPartner?.keyAccountManager && (
                            <>
                                <Grid item xs={12} md={5}>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        Key Account Manager
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={7}>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            display: "flex",
                                            alignItems: "center"
                                        }}
                                    >
                                        {profileImage && (
                                            <img
                                                src={profileImage}
                                                width={24}
                                                height={24}
                                                style={{
                                                    marginRight: "5px",
                                                    borderRadius: "50%"
                                                }}
                                                alt="KAM"
                                            />
                                        )}

                                        {selectedPartner?.keyAccountManager ||
                                            "-"}
                                    </Typography>
                                </Grid>
                            </>
                        )}

                        {/* <Grid item xs={12} md={5}>
              <Typography variant="body2" color="text.secondary">
                Last Update
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography variant="body2">
                {selectedPartner?.lastUpdatedTime || "-"}
              </Typography>
            </Grid> */}

                        {/* <Grid item xs={12} md={5}>
              <Typography variant="body2" color="text.secondary">
                Status
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Chip
                label={
                  selectedPartner?.status === "Active" ? "Active" : "Inactive"
                }
                color={
                  selectedPartner?.status === "Active" ? "success" : "default"
                }
                variant="outlined"
                size="small"
              />
            </Grid> */}
                    </Grid>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Company Listing */}
                {!loading ? (
                    companyData?.length > 0 ? (
                        <>
                            <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                sx={{ mb: 1 }}
                            >
                                Companies Listing
                            </Typography>

                            <TableContainer
                                component={Paper}
                                sx={{
                                    maxHeight: 400,
                                    boxShadow: "none!important",
                                    border: "1px solid #F2F2F2"
                                }}
                            >
                                <Table
                                    aria-label="Companies Table"
                                    stickyHeader
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                sx={{
                                                    backgroundColor: "#E3E8EF"
                                                }}
                                            >
                                                Company ID
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    backgroundColor: "#E3E8EF"
                                                }}
                                            >
                                                Associated Companies
                                            </TableCell>
                                            {/* <TableCell sx={{ backgroundColor: "#E3E8EF" }}>
                        Status
                      </TableCell> */}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {companyData.map((row, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    "&:last-child td, &:last-child th":
                                                        { border: 0 }
                                                }}
                                            >
                                                <TableCell
                                                    sx={{
                                                        padding: "10px",
                                                        minWidth: "120px"
                                                    }}
                                                >
                                                    {row?.companyID || "-"}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        padding: "10px"
                                                    }}
                                                >
                                                    {row?.companyLogo && (
                                                        <img
                                                            src={GenerateImage(
                                                                row?.companyLogo,
                                                                row?.companyRecId
                                                            )}
                                                            width="30"
                                                            height="30"
                                                            style={{
                                                                marginRight: 10
                                                            }}
                                                            alt="Company Logo"
                                                        />
                                                    )}
                                                    {row?.companyname || "-"}
                                                </TableCell>
                                                {/* <TableCell sx={{ padding: "10px", minWidth: "120px" }}>
                          <Chip
                            label={
                              row?.status === "Active" ? "Active" : "Inactive"
                            }
                            color={
                              row?.status === "Active" ? "success" : "default"
                            }
                            variant="outlined"
                            size="small"
                          />
                        </TableCell> */}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    ) : (
                        <Typography textAlign="center" color="text.secondary">
                            No Data Found
                        </Typography>
                    )
                ) : (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="50vh"
                    >
                        <ThreeDot
                            color="#1976d2"
                            size="medium"
                            text=""
                            textColor=""
                        />
                    </Box>
                )}
            </Box>
        </Drawer>
    );
};
